export const IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
